// extracted by mini-css-extract-plugin
export default {"container":"lis_3J0es","colored":"lis_col_1aIye"};